<template>
  <b-row v-if="item">
    <b-col>
      <h6>{{ $t('views.exsbitems.show.itemPictures') }}:</h6>
      <b-row v-for="(itemPicture, index) in item.itemPictures" v-bind:key="'documentFile-' + index">
        <b-col>
          <b-row v-if="index !== 0">
            <b-col>
              <hr class="mt-2 mb-2">
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="float-left picturebox mb-2">
                <b-img v-if="itemPicture.picturePreview" :src="itemPicture.picturePreview" alt="picture"/>
                <img v-else src="/static/img/no-image.png" alt="user avatar"/>
              </div>
              <div class="float-left ml-3">
                <p class="m-0">
                  <b>{{ itemPicture.fileName }}<span v-if="itemPicture.isMain"> ({{$t('views.exsbitems.show.isMainPicture') }})</span>
                  </b><br>
                </p>
                <b-row v-if="!itemPicture.isMain">
                  <b-col>
                    <b-button class="btn btn-success" size="sm" @click="setAsMain(itemPicture)">
                      {{ $t('buttons.setAsMain') }}
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button class="btn btn-danger mt-2" size="sm" @click="deletePicture(itemPicture)">
                      {{ $t('buttons.delete') }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr>
          <button type="button"
                  class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg"
                  v-b-tooltip.hover :title="$t('global.chooseImage')"
                  @click="uploadPicture()">
          </button>
          <span class="h6">{{ $t('buttons.uploadPicture') }}</span>
        </b-col>
      </b-row>
    </b-col>
    <UploadPictureModal v-model="pictureUploaded"></UploadPictureModal>
  </b-row>
</template>

<script>
import UploadPictureModal from '@/components/Dashboard/Views/BusinessBundle/exsbitem/modals/UploadPictureModal'
import getIdFromLink from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'

export default {
  name: 'ItemPictures',
  props: ['item'],

  data () {
    return {
      pictureUploaded: 0
    }
  },

  components: {
    UploadPictureModal
  },

  watch: {
    pictureUploaded: function () {
      if (this.pictureUploaded === 1) {
        this.$emit('input', 1)
        this.pictureUploaded = 0
      }
    }
  },

  methods: {
    setAsMain (item) {
      const response = new ApiService(item['@id']).put({ isMain: 1 })
      response.then(res => {
        this.$emit('input', 1)
      })
    },
    deletePicture (item) {
      remove(item['@id'], () => {
        this.$emit('input', 1)
      })
    },
    uploadPicture () {
      this.$store.state.modals.uploadPicture.show = 1
      this.$store.state.modals.uploadPicture.path = 'api/e_x_s_b_items/' + getIdFromLink(this.item['@id']) + '/upload_picture'
    }
  }
}
</script>
